module.exports = __webpack_public_path__ + "static/media/social_02.746c7731.jpg";